<template>
  <popup class="preview-popup">
    <div class="preview-wrap wrap-common rel" >
      <p class="tc title">Preview</p>

      <div class="iphone-wrap rel tc">
        <p class="pab iphone-cover" :style="primaryStyle"></p>
        <img src="../../static/images/popup/iphone-frame.png" class="frame-img">

        <div class="iframe-wrap" :style="primaryStyle">
          <iframe frameborder="no" class="phone-frame" scrolling="auto" :src="homeURL"></iframe>
        </div>
      </div>

      <p class="close-btn btn-common" @click="handleClose">
        <i class="icon-close-line iconfont"></i>
      </p>
    </div>
  </popup>
</template>

<script>
import qrcodeVue from 'qrcode.vue';
import popup from "./popup.vue";
import 'remixicon/fonts/remixicon.css';

export default {
  data() {
    return {
      close: true,
      blockItems: [],
      primaryColor: '#FFFFFF',
      textColor: '#000000',
      accentColor: '#FEB727',
    }
  },
  // props:['dashboard'],
  props: {
    dashboard: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  components: {
    'qrcode-vue': qrcodeVue,
    popup
  },

  methods: {
    handleClose() {
      this.$emit('close', this.close)
    },

    showImage(item) {
      return item.image && item.image.length > 0;
    },
    showIcons(item) {
      return item.icons && item.icons.length > 0;
    },
    getLink(item){
      if(item.url && item.url.length>0){
        return item.url;
      }
      return null;
    },
  },

  computed: {
    filteredBlocks() {
      const dashboard = this.dashboard || {};
      const blocks = dashboard.blocks || [];

      return blocks.filter((row) => {
        return !!(row.state);
      }).sort((first, second) => {
        return second.position - first.position;
      })
    },
    hostname() {
      return window.location.host || 'freelink.com';
    },
    scheme() {
      return window.location.protocol || 'https:';
    },
    username() {
      const dashboard = this.dashboard || {};
      const user = dashboard.user || {};
      return user.username || '';
    },
    homeURL() {
      return `${this.scheme}//${this.hostname}/${this.username}`
    },
    primaryStyle() {
      return {
        backgroundColor: `${this.primaryColor}`,
      }
    },
    textStyle() {
      return {
        color: `${this.textColor}`,
      };
    },
    blockStyle() {
      return {
        color: `${this.textColor}`,
        backgroundColor: `${this.accentColor}`,
      }
    },

  },
  mounted(){

    this.primaryColor = this.dashboard.options.primary_color || this.primaryColor;
    this.textColor = this.dashboard.options.text_color || this.textColor;
    this.accentColor = this.dashboard.options.accent_color || this.accentColor;
  }
}
</script>

